import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./auth";

/**
 * Route guard.
 *
 * This is a convenience, not a security boundary: every admin endpoint checks
 * the token and the permission server-side. Removing this component in devtools
 * gets you an empty console full of 401s, not data.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((state) => state.accessToken);
  const location = useLocation();

  if (!token) {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
